




















import { Component, Vue, Model } from 'vue-property-decorator'

@Component
export default class ResizeHeight extends Vue {
  @Model('change', { type: String }) private readonly value!: MessageType

  private changeValue(val: MessageType) {
    this.$emit('change', val)
  }
}
